import { HttpInterceptorFn } from '@angular/common/http';
import { AuthUtility } from '../utility/auth-utility';

export const appInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.url.includes('/api/carrito') || request.url.includes('/api/pedido')) {
        console.debug('[http]', request.method, request.url);
    }

    if (!AuthUtility.isAuthenticated() || request.headers.has('Authorization')) {
        return next(request);
    }

    const token = AuthUtility.getToken();
    if (!token) {
        return next(request);
    }

    return next(request.clone({
        setHeaders: {
            Authorization: 'Bearer ' + token
        }
    }));
};
